<template>
  <v-dialog v-model="dialog" max-width="900" scrollable>
    <v-card>
      <v-card-title>
        <h3>Códigos ausentes no INDGER em relação a BDGD</h3>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="entidadeSelecionada"
              :items="entidades"
              label="Campo"
              dense
              solo
            />
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              v-model="search"
              label="Buscar"
              append-icon="mdi-magnify"
              dense
              solo
              clearable
            />
          </v-col>
        </v-row>
        <v-data-table
          :headers="[{ text: 'Código', value: 'cod' }]"
          :items="dadosComparacao[entidadeSelecionada]"
          :search="search"
          class="elevation-2"
          dense
          :items-per-page="10"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('close')">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "DialogDetalhesComparacaoBdgdIndger",
    props: {
      value: {
        // para v-model
        type: Boolean,
        required: true,
      },
      dadosComparacao: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        entidades: [
          { text: "Alimentadores", value: "alimentadores" },
          { text: "Subestações", value: "sub" },
          { text: "Conjuntos", value: "conj" },
        ],
        entidadeSelecionada: "alimentadores",
        search: "",
      };
    },
    watch: {
      dialog(val, oldVal) {
        // Reseta search e entidade ao abrir dialog
        if (val && !oldVal) {
          this.entidadeSelecionada = "alimentadores";
          this.search = "";
        }
      },
    },
    computed: {
      dialog: {
        get() {
          return this.value;
        },
        set(val) {
          if (!val) this.$emit("close");
        },
      },
    },
  };
</script>
